require('./bootstrap');
window.$ = require('jquery');
require('./front');
